import { LogOut } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { Avatar } from "../ui-bits";

export default function UserMenu() {
  const { user, logout } = useAuth();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="user-menu" className="ml-1 flex items-center gap-2 rounded-md hover:bg-muted px-1.5 py-1 transition-colors">
          <Avatar name={user?.name || "?"} userId={user?.id} online={user ? true : undefined} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <div className="px-2 py-1.5">
          <p className="text-sm font-semibold" data-testid="user-menu-name">{user?.name}</p>
          <p className="text-xs text-muted-foreground">{user?.email}</p>
          <span className="inline-block mt-1 text-[10px] uppercase tracking-wider font-semibold text-navy dark:text-blue-300 bg-muted rounded px-1.5 py-0.5">{user?.role}</span>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="logout-button" className="text-[#E31E24]" onClick={logout}>
          <LogOut size={14} className="mr-2" />Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
